module.exports = __webpack_public_path__ + "static/media/payroll-bg.6974f794.jpg";